import { AfterViewChecked, AfterViewInit, EventEmitter, Component, ElementRef, Output, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SendCodeType } from '../../enums/send-code-type.enum';
import { OtpService } from '../../services/otp.service';
import { CheckOTPCode_Request } from '../../models/CheckOTPCode_Request.model';
import { GetDraft_Request } from '../../models/GetDraft_Request';
import { UtilService } from '../../services/util.service';
import { GetPhone_Request } from '../../models/GetPhone_Request.model';
import { SendOTPCode_Request } from '../../models/SendOTPCode_Request.model';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { continueProcess } from '../../models/ContinueProcess_Request';
import { Draft } from '../../services/draft.service';
import { QuestionnaireService } from '../../services/questionnaire.service';
import { Router } from '@angular/router';
import { LeadService } from "../../services/lead.service";
import { DraftHttpService } from '../../services/draft-http.service';
import { TranslateService } from '@ngx-translate/core';
import { GetDraft_Response } from '../../models/GetDraft_Response.model';
import { NewFormOTP_Request } from '../../models/NewFormOTP_Request.model';
@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit, AfterViewChecked {

  @Input() userId: string;
  selectedPhoneIndex = 0;
  phones: string[];
  currentStepSubject: BehaviorSubject<number> = new BehaviorSubject(1);
  phonesAvailableSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  noPhonesForIDSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  advisorNotExist: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isDevMode: boolean;
  errorAdvisor = false;
  @Output() submitCb: EventEmitter<SendOTPCode_Request> = new EventEmitter<SendOTPCode_Request>();
  @Input() phoneNumber: string;
  errorInConfirm: string;
  isloading: boolean = false;
  isFinish: boolean = false;
  idFromConsultant: string;
  partialFormNotExist: string;
  isAdvisor = false;
  isNewForm = false;
  whatsAppLink: string = environment.common.whatsAppLink;

  constructor(
    public otpService: OtpService,
    private draft: Draft,
    private draftHttpService: DraftHttpService,
    private questionnaireService: QuestionnaireService,
    private router: Router,
    private leadService: LeadService,
    private httpClient: HttpClient,
    public utilService: UtilService,
    private translate: TranslateService,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    this.isNewForm = this.otpService.isNewForm;
    if (this.userId) {
      if (this.questionnaireService.getIsAdvisor()) {
        this._getPhonesConsulant();
        this.isAdvisor = true;
      }
      else {
        this._getPhones();
        this.isAdvisor = false;
      }
    }

    this.idFromConsultant = this.translate.instant('otp.errors.id-from-consultant');
    this.idFromConsultant = this.idFromConsultant.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')

    this.partialFormNotExist = this.translate.instant('otp.errors.partial-form-not-exist');
    this.partialFormNotExist = this.partialFormNotExist.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
  }

  ngAfterViewChecked() {
    if (this.elementRef.nativeElement.querySelector('#open-new-request')) {
      this.elementRef.nativeElement.querySelector('#open-new-request').addEventListener('click', this.routeToNewForm.bind(this));
    }
    if (this.elementRef.nativeElement.querySelector('#open-new-request-2')) {
      this.elementRef.nativeElement.querySelector('#open-new-request-2').addEventListener('click', this.routeToNewForm.bind(this));
    }
  }

  routeToNewForm(e: Event) {
    this.router.navigate(["/questionnaire/user-details/1"]);
    e.stopPropagation();
    e.preventDefault();
    return false;
  }

  private _getPhonesConsulant() {
    this.isloading = true;
    this.phones = [];

    let tz_request_body: GetPhone_Request = { TZ: this.userId };

    this.otpService.getConsulantPhone$(tz_request_body).subscribe((res) => {
      if (res && res.hasOwnProperty('phone') && res.phone !== "" && res.phone !== "-1") {
        this.phonesAvailableSubject.next(true);
        this.phones = res.phone;
        this.errorAdvisor = false;
        this.errorInConfirm = "";
      }
      else if (res && res.hasOwnProperty('phone') && res.phone === "") {
        this.advisorNotExist.next(true);
        this.errorAdvisor = false;
        this.errorInConfirm = "";
      }
      else if (res && res.hasOwnProperty('phone') && res.phone === "-1") {
        this.handleErrors("consultant-details");
        this.errorAdvisor = true;
      }
      this.isloading = false;
    }, (error) => {
      this.handleErrors();
      this.isloading = false;
      this.errorAdvisor = true;
    });
  }

  private _getPhones() {
    this.isloading = true;
    this.phones = [];

    let tz_request_body: GetPhone_Request = { TZ: this.userId };

    this.otpService.getPhones$(tz_request_body).subscribe((res) => {
      if (res && res.hasOwnProperty('phone') && res.phone !== "") {
        let params: continueProcess = {
          userId: this.userId,
          ConsultantId: "empty",
          ConsultantIdnt: ""
        };
        this.continueProcess$(params).subscribe(res => console.log(res));
        this.phonesAvailableSubject.next(true);
        this.phones = [res.phone];
      }
      else if (res && res.hasOwnProperty('phone') && res.phone === "") {
        this.noPhonesForIDSubject.next(true);
      }
      this.errorInConfirm = "";
      this.isloading = false;
    }, (error) => {
      this.handleErrors();
      this.isloading = false;
    });
  }

  continueProcess$(params: continueProcess) {
    let apiUri = environment.apiUri + "/TofesMashkanta";
    const url = `${apiUri}/continueProcess`;
    return this.httpClient.post(url, params);
  }

  handleErrors(errorType?: string) {
    this.errorInConfirm = this.translate.instant('USER_DETAILS.Q4.ERROR_IN_EXECUTING_ACTION');

    if (errorType === 'code-not-valid') {
      this.errorInConfirm = this.translate.instant('otp.errors-in-otp-code.code-not-valid');
    } else if (errorType === 'code-three-tries') {
      this.errorInConfirm = this.translate.instant('otp.errors-in-otp-code.code-three-tries');
    } else if (errorType === 'partial-form') {
      this.errorInConfirm = this.translate.instant('otp.errors-in-otp-code.partial-form');
      this.errorInConfirm = this.errorInConfirm.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
    } else if (errorType === 'blocked-id') {
      this.errorInConfirm = this.translate.instant('otp.errors-in-otp-code.blocked-id');
    } else if (errorType === 'changes-in-borrowers-composition') {
      this.errorInConfirm = this.translate.instant('otp.errors-in-otp-code.changes-in-borrowers-composition');
      this.errorInConfirm = this.errorInConfirm.replace('WhatsApp', '<a href="' + this.whatsAppLink + '" target=_blank>WhatsApp</a>')
    } else if (errorType === 'consultant-register') {
      this.errorInConfirm = this.translate.instant('otp.errors-in-otp-code.consultant-register');
    } else if (errorType === 'consultant-details') {
      this.errorInConfirm = this.translate.instant('otp.errors-in-otp-code.consultant-details');
    }
  }

  getCode(otpRequest: SendOTPCode_Request) {
    this.selectedPhoneIndex = otpRequest.phoneIndex;
    this.isloading = true;
    if (otpRequest && otpRequest.hasOwnProperty('sendCodeType')) {
      if (otpRequest.sendCodeType === SendCodeType.IVR) {
        this.otpService.getIvrCode$(otpRequest).subscribe((res) => {
          this.errorInConfirm = "";
          this.isloading = false;
          if (res && res.hasOwnProperty('success') && res.success) {
            this.goToConfirmCode();
          }
        }, (error) => {
          this.isloading = false;
          this.handleErrors();
        });
      } else if (otpRequest.sendCodeType === SendCodeType.SMS) {
        this.otpService.getSmsCode$(otpRequest).subscribe((res) => {
          this.errorInConfirm = "";
          this.isloading = false;
          if (res && res.hasOwnProperty('success') && res.success) {
            this.goToConfirmCode();
          }
        }, (error) => {
          this.isloading = false;
          this.handleErrors();
        });
      }
    }
  }

  getCodeNewForm(otpRequest: SendOTPCode_Request) {
    this.isloading = true;
    if (otpRequest && otpRequest.hasOwnProperty('sendCodeType')) {
      let params: NewFormOTP_Request = {
        phone: this.phoneNumber,
        sendCodeType: otpRequest.sendCodeType,
        TZ: this.draft.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "2")[0].answers[0],
        isFromYad2: this.leadService.isFromYad2

      };
      this.otpService.newFormOTP$(params).subscribe((res) => {
        this.errorInConfirm = "";
        this.isloading = false;
        if (res && res.hasOwnProperty('success') && res.success) {
          this.goToConfirmCode();
        }
      }, (error) => {
        this.isloading = false;
        this.handleErrors();
      });
    }
  }

  cofirmCode(req: CheckOTPCode_Request) {
    this.isloading = true;
    this.otpService.confirmCode$(req).subscribe((res) => {
      this.errorInConfirm = "";
      this.isloading = false;
      this.otpService.isNewForm = false;
      if (res && res.hasOwnProperty('success') && res.success) {
        this.submitCb.emit();
        if (this.questionnaireService.getIsAdvisor()) {
          this.otpService.nextStatus("finish");
        }
        else {
          this.isFinish = true;
        }
        this.otpService.confirmCode = false;
        this.otpService.phoneOk = false;
      }
      else {
        this.handleErrors();
      }

      // this.handleErrors('partial-form');

    }, (error) => {
      if ((error.type && error.type === 2) && (error.code && error.code.message === '1')) {
        this.errorInConfirm = this.translate.instant('otp.errors-in-otp-code.code-not-valid');
        this.isloading = false;
      }
      else {
        if ((error.type && error.type === 2) && (error.code && error.code.message === '2')) {
          this.errorInConfirm = this.translate.instant('otp.errors.expired');
          this.isloading = false;
        }
        else {
          this.isloading = false;
          this.handleErrors();
        }
      }
    });
  }


  goToGetCode() {
    this.currentStepSubject.next(1);
    this.focusToElement(`div[data-dropdown-id="choosePhone"]`);
  }

  goToConfirmCode() {
    this.currentStepSubject.next(2);
  }

  finish() {
    this.isloading = true;
    let params: GetDraft_Request = {
      userId: this.userId
    };
    this.draftHttpService.getDraft$(params).subscribe(
      (res: GetDraft_Response) => {
        console.log(res);
        this.questionnaireService.setAsmachta(res.oppID);
        this.draft.arrDataBase = res.draft;
        this.draft.updateSavedDraft(res.draft);
        this.draft.autoForm = true;
        this.questionnaireService.setIsAdvisor(false);
        this.router.navigate(["/questionnaire/user-details", 1]);
        this.errorInConfirm = "";
        this.isloading = false;
      }, err => {
        if ((err.type && err.type === 2) && (err.code && err.code.message === '2')) {
          this.errorInConfirm = this.translate.instant('otp.errors.expired');
          this.isloading = false;
        }
        else {
          this.errorInConfirm = this.translate.instant('USER_DETAILS.Q4.ERROR_IN_EXECUTING_ACTION');
          this.isloading = false;
        }
      });
  }

  focusToElement(selector: string) {
    const selectedElement = Array.from(document.querySelectorAll(selector));

    if (selectedElement && selectedElement.length > 0) {
      const nowActiveElement = document.activeElement;
      (nowActiveElement as HTMLElement).blur();
      setTimeout(() => (selectedElement[0] as HTMLElement).focus(), 0);
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/login/otp/otp.component.ts